import Vue from "vue";
import Vuex from "vuex";

import Contracts from "@/assets/contracts";
import ERC721ABI from "@/assets/ABIS/ERC721";
import ERC20ABI from "@/assets/ABIS/ERC20";
import StakeForVnftsABI from "@/assets/ABIS/StakeForVnfts"; // This one can be removed later after migration is cleared
import StakeForVnfts2ABI from "@/assets/ABIS/StakeForVnfts2";
import VnftLpAbi from "@/assets/ABIS/VnftLp";
import MasterChefAbi from "@/assets/ABIS/MasterChef";
import LotteryAbi from "@/assets/ABIS/Lottery";
import MultiVnftAbi from "@/assets/ABIS/MultiVnft";
import NFTRaceAbi from "@/assets/ABIS/NFTRace";
import NFTRaceMuseAbi from "@/assets/ABIS/NFTRaceMuse";
import NiftyAnimalsAbi from "@/assets/ABIS/NiftyAnimals";

import vNFTABI from "@/assets/ABIS/vNFT";
import vNFTxABI from "@/assets/ABIS/vNFTx";
import NiftyAddonsABI from "@/assets/ABIS/NiftyAddons";

import AirdropperABI from "@/assets/ABIS/Airdropper";
import VnftDistributionABI from "@/assets/ABIS/VnftDistribution";

import Web3 from "web3";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    web3: null,
    vNFTContract: null,
    AirdropperContract: null,
    MuseTokenContract: null,
    LotteryContract: null,
    contracts: {},
    account: null,
  },
  mutations: {
    setWeb3: async function(state, web3, vueInstance) {
      state.contracts = Contracts;
      state.vNFTContract = new web3.eth.Contract(vNFTABI, Contracts.vNFT);
      state.AirdropperContract = new web3.eth.Contract(
        AirdropperABI,
        Contracts.Airdropper
      );
      state.MuseTokenContract = new web3.eth.Contract(
        ERC20ABI,
        Contracts.MuseToken
      );
      state.StakeForVnftsContract = new web3.eth.Contract(
        StakeForVnftsABI,
        Contracts.StakeForVnfts
      );
      state.StakeForVnftsContract2 = new web3.eth.Contract(
        StakeForVnfts2ABI,
        Contracts.StakeForVnfts2
      );
      state.UniEthMuseContract = new web3.eth.Contract(
        ERC20ABI,
        Contracts.UniEthMuse
      );
      state.MasterChefContract = new web3.eth.Contract(
        MasterChefAbi,
        Contracts.MasterChef
      );
      state.LotteryContract = new web3.eth.Contract(
        LotteryAbi,
        Contracts.Lottery
      );

      state.MultiVnftContract = new web3.eth.Contract(
        MultiVnftAbi,
        Contracts.MultiVnft
      );
      state.NiftyAddonsContract = new web3.eth.Contract(
        NiftyAddonsABI,
        Contracts.NiftyAddons
      );
      state.vNFTxContract = new web3.eth.Contract(vNFTxABI, Contracts.vNFTx);
      state.AirdropperContract = new web3.eth.Contract(
        AirdropperABI,
        Contracts.Airdropper
      );

      state.VnftLpContract = new web3.eth.Contract(VnftLpAbi, Contracts.VnftLp);
      state.VnftLpOldContract = new web3.eth.Contract(
        VnftLpAbi,
        Contracts.VnftLpOld
      );
      state.NFTRace = new web3.eth.Contract(NFTRaceAbi, Contracts.NFTRace);
      state.NFTRaceMuse = new web3.eth.Contract(
        NFTRaceMuseAbi,
        Contracts.NFTRaceMuse
      );

      // wrapped projects
      state.MemeContract = new web3.eth.Contract(vNFTABI, Contracts.MEME);
      state.ChonkerContract = new web3.eth.Contract(vNFTABI, Contracts.Chonker);

      state.MemeFactoryContract = new web3.eth.Contract(
        vNFTABI,
        Contracts.MemeFactory
      );

      state.DokiContract = new web3.eth.Contract(vNFTABI, Contracts.Doki);
      state.SergsContract = new web3.eth.Contract(vNFTABI, Contracts.Sergs);
      state.Doki2Contract = new web3.eth.Contract(vNFTABI, Contracts.Doki2);

      state.NiftyAnimalsContract = new web3.eth.Contract(
        NiftyAnimalsAbi,
        Contracts.NiftyAnimals
      );

      state.AxiesContract = new web3.eth.Contract(vNFTABI, Contracts.Axies);
      state.VnftDistribution = new web3.eth.Contract(
        VnftDistributionABI,
        Contracts.VnftDistribution
      );

      state.account = (await web3.eth.getAccounts())[0];
      state.web3 = web3;

      console.log("set Web3");
    },
  },
  actions: {
    connectWallet: async function(context, vue) {
      const provider = await vue.$web3Modal.connect();
      const web3 = new Web3(provider);
      context.commit("setWeb3", web3, vue);

      provider.on("accountsChanged", (accounts) => {
        context.dispatch("connectWallet", vue);
      });

      // Subscribe to chainId change
      provider.on("chainChanged", (chainId) => {
        context.dispatch("connectWallet", vue);
      });

      // Subscribe to provider disconnection
      provider.on("disconnect", (error) => {
        context.dispatch("connectWallet", vue);
      });
    },
  },
  modules: {},
});
